// maintain alphabetical order
export const jaBrandsDashboard = {
  BrandsDashboardDrillMessage: '下のグラフまたは表をクリックして、任意のオブジェクトを詳細に調べることができます。',
};